import {NotifyUserHasChangedUseCase} from './../../user/application/notify-user-has-change.use-case';
import {Injectable} from "@angular/core";
import {ClearCartUseCase} from "@app/core/cart/application/clear-cart.use-case";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {DeliveryPointLocal} from "@app/core/delivery-point/domain/delivery-point.local";
import {from, Observable} from "rxjs";
import {
    SendDeliveryPointSelectionUseCase
} from './../../delivery-point/application/send-delivery-point-selection.use-case';

export interface SaveDeliveryPointUseCaseParams {
    deliveryPoint: DeliveryPoint,

    /**
     * If true, the cart will be cleared before saving the delivery point.
     * @defaultValue true
     */
    removeCartLines?: boolean,

    /**
     * If true, the delivery point will be notified to the backend.
     * @defaultValue false
     */
    sendDeliveryPoint?: boolean,
}

/**
 * Use Case for selecting a delivery point.
 */
@Injectable({
    providedIn: "root",
})
export class SaveDeliveryPointUseCase {
    constructor(
        private deliveryRepository: DeliveryPointLocal,
        
        private clearCartUseCase: ClearCartUseCase,
        private sendDeliveryPointSelectionUseCase: SendDeliveryPointSelectionUseCase,
        private notifyUserHasChangedUseCase: NotifyUserHasChangedUseCase,
    ) { }

    execute(params: SaveDeliveryPointUseCaseParams): Observable<void> {
        const {deliveryPoint,removeCartLines = true, sendDeliveryPoint = false} = params;
        return from(this.saveDeliveryPoint({deliveryPoint,removeCartLines, sendDeliveryPoint}))
    }

    private async saveDeliveryPoint(params: SaveDeliveryPointUseCaseParams): Promise<void> {
        if ( params.sendDeliveryPoint) {
            await this.sendDeliveryPointSelectionUseCase.execute(params.deliveryPoint.code);
        }
        this.deliveryRepository.saveDeliveryPoint(params.deliveryPoint);
        if(params.removeCartLines) {
            await this.clearCartUseCase.execute();
        }
        this.notifyUserHasChangedUseCase.execute({deliveryPointCode: params.deliveryPoint.code})
    }
}
